import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

const BeneficiaryTablePagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        mt: 3,
      }}
    >
      <IconButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        sx={{ color: 'text.secondary', borderRadius: '4px', width: '40px', height: '40px' }}
      >
        <ChevronLeft />
      </IconButton>

      {pages.map((page) => (
        <IconButton
          key={page}
          onClick={() => onPageChange(page)}
          sx={{
            width: '40px',
            height: '40px',
            borderRadius: 0,
            backgroundColor: currentPage === page ? 'primary.main' : 'transparent',
            color: currentPage === page ? 'white' : 'text.primary',
            '&:hover': {
              backgroundColor: currentPage === page ? 'primary.dark' : 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <Typography variant="body2" fontWeight={500}>
            {page}
          </Typography>
        </IconButton>
      ))}

      <IconButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        sx={{ color: 'text.secondary', borderRadius: 0, width: '40px', height: '40px' }}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default BeneficiaryTablePagination;
